// removed by extract-text-webpack-plugin
module.exports = {"list":"list__3Avq8","search":"search__2wcWR"};


//////////////////
// WEBPACK FOOTER
// ./components/searchableList/style.css
// module id = VKRH
// module chunks = 8